import CONSTANTS from '../constants'
import { isLoggedIn } from '../../utils/helper'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { addDays } from 'date-fns'

const INITIAL_STATE = {
    loader: false,
    isUserLogin: isLoggedIn(),
    hasError: false,
    email: null,
    role: null,
    errorMessage: '',
    id: null,
    orgId: '',
    isLoggedIn: false,
    isLoginModal: false,
    isOpened: false,
    modalSingup: 0,
    noOfEventShow: 4,
    eventData: [],
    selectedEventId: '',
    bookingFormPage: 0,
    bookingFormDetail: {
        personal_info: null,
        payment_detail: null
    },
    isCanvasShow: false,
    partnerDetails: EMPTY_OBJECT,
    startValue: new Date(),
    endValue: addDays(new Date(), 15),
    isLoading: false,
    loginPayload: EMPTY_OBJECT,
    userDetails: EMPTY_OBJECT,
    selectedPassType: 0,
    selectedPassId: '',
    passData: EMPTY_OBJECT,
    selectEventType: '',
    ExpiryTimeSession: 900000,
    isDirectBooking: false,
    logoImage: '',
    favIcon: '',
    cardList: EMPTY_ARRAY,
    selectedFacilityId: '',
    selectedYearForLabel: '',
    eventViewStyle: 'list',
    facilitiesTimezone: '',
    allEventsData: [],
}

const globalReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        //global HANDLING
        case CONSTANTS.GLOBAL_STATE_KEY_REQUEST:
            return { ...state, loader: false, ...action.data, isAuthenticated: true, hasError: false, errorMessage: '' }

        // slug routes
        case CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST:
            return { ...state, loader: true, errorMessage: null }

        case CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS:
            return { ...state, loader: false, partnerDetails: action?.data, hasError: false, errorMessage: null }

        case CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE:
            return { ...state, loader: false, partnerDetails: null, hasError: true, errorMessage: action?.errorMessage }
        default:
            return state
    }
}

export default globalReducers
